import { AxisLabel, AxisTick } from "./utils"


export type YAxisProps = {
    yScale: any,
    tickFormattingFunction: (tickVal: number) => string,
    chartDimensions: { height: number, width: number },
    margins: { top: number, bottom: number, left: number, right: number }
}


export function YAxis({ yScale, tickFormattingFunction, chartDimensions, margins }: YAxisProps) {

    return (
        <g>
            {yScale.ticks().map((tickVal: number, idx: number) => {
                return (
                    <g className="tick" key={tickVal} transform={`translate(${margins.left}, ${yScale(tickVal)})`}>
                        <AxisLabel translation={{ x: -10, y: 5 }} tickVal={tickVal} tickFormattingFunction={tickFormattingFunction} />
                        <AxisTick orientation="horizontal" />
                        <line y1={0} y2={0} x1={0} x2={chartDimensions.width - margins.right - margins.left} stroke={'#C0C0BB'} />
                    </g>
                )
            })}

            <line y1={margins.top} y2={chartDimensions.height - margins.bottom} x1={margins.left} x2={margins.left} stroke={'#C0C0BB'} />

        </g>
    )


}